var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 25,
    viewBox: "0 0 48 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 23,
    rx: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0459 14.46H18.7159V15.13H10.5659V14.46H14.2159V12.77H11.5859V10H16.9059V8.6H11.5659V7.93H17.7059V10.66H12.3959V12.11H17.9159V12.77H15.0459V14.46ZM25.9951 9.12V8.89H20.6551V8.22H26.8051V9.12C26.8051 10.26 26.8051 11.55 26.4551 13.49L25.6351 13.4C25.9951 11.57 25.9951 10.23 25.9951 9.12ZM19.7851 14.25H27.8951V14.93H19.7851V14.25ZM36.3343 7.28V13.83H35.5143V7.28H36.3343ZM29.9843 10.1C29.9843 10.99 30.6443 11.61 31.5143 11.61C32.4043 11.61 33.0643 10.99 33.0643 10.1C33.0643 9.23 32.4043 8.61 31.5143 8.61C30.6443 8.61 29.9843 9.23 29.9843 10.1ZM33.8643 10.1C33.8643 11.4 32.8543 12.32 31.5143 12.32C30.1843 12.32 29.1843 11.4 29.1843 10.1C29.1843 8.81 30.1843 7.9 31.5143 7.9C32.8543 7.9 33.8643 8.81 33.8643 10.1ZM31.3843 15.37H36.6043V16.04H30.5643V13.16H31.3843V15.37Z",
    fill: "#333334"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.fb09f71250f1801693fb93839de5ea98.svg";
export { ForwardRef as ReactComponent };